var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCskh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1111 12H10.8888C10.4 12 10 12.405 10 12.8999V18.2997C10 18.7947 10.4 19.1999 10.8888 19.1999H11.7776V21L14.4443 19.1999H17.1109C17.5997 19.1999 18 18.7947 18 18.3001V12.9002C18 12.4053 17.5997 12 17.1111 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.2846L10.9229 11C12.6227 9.68249 15.3773 9.68249 17.0763 11L18 10.2846C15.7903 8.57181 12.2097 8.57181 10 10.2846Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1666 12.3333C23.1666 7.7305 19.0642 4 14 4C8.93725 4 4.83343 7.7305 4.83343 12.3333C3.82087 12.3333 3 13.0795 3 14V19C3 19.9205 3.82087 20.6667 4.83343 20.6667H7.58343C8.0897 20.6667 8.5 20.294 8.5 19.8333V15.6667C8.5 15.2085 8.2712 14.5208 7.99152 14.14L6.66685 12.3335C6.66685 8.651 9.9498 5.66675 14.0002 5.66675C18.0519 5.66675 21.3337 8.651 21.3337 12.3335L20.0087 14.14C19.7291 14.5208 19.5 15.2085 19.5 15.6667V20.0662C18.1564 21.4538 16.1934 22.3333 14 22.3333H12.1666V24H14C16.997 24 19.6485 22.6873 21.3208 20.6667H23.1666C24.1791 20.6667 25 19.9205 25 19V14C25 13.0795 24.1791 12.3333 23.1666 12.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCskh);
export default __webpack_public_path__ + "static/media/cskh.d4e5f205c20992af4243c122e3415862.svg";
export { ForwardRef as ReactComponent };